module.exports = __webpack_public_path__ + "img/RJC_LP_rjc.aba2cf5.jpg";